// //=========================================
import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  Button,
  Offcanvas,
  Container,
  Spinner,
  Table,
  DropdownButton,
  ButtonGroup,
  NavDropdown,
} from "react-bootstrap";
import "../style/admin.css";
import Moment from "react-moment";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import CartFilter from "./CartFilter";
import { Flag } from "react-bootstrap-icons";
import { FiMinus, FiPlus } from "react-icons/fi";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { MdOutlineFileDownload } from "react-icons/md";
import * as XLSX from "xlsx";
import Dropdown from "react-bootstrap/Dropdown";
import html2canvas from "html2canvas";
import { apibasePath } from "../config";
import LoadingImg from "../shared/LoadingImg";
const Cart = () => {
  const [show, setShow] = useState(false);
  const [stock, setStock] = useState([]);
  const [logo, setLogo] = useState(null);
  const [name, setName] = useState(" ");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [customerData, setCustomerData] = useState([]);

  const [openSubTable, setOpenSubTable] = useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [pdf, setPdf] = useState([]);

  const Api_Url = `${apibasePath}/client/cart-summary/`;
  const Api_url = `${apibasePath}/client/profiles/company/`;
  const Token = localStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let res = await axios.get(Api_Url, {
          headers: { Authorization: `bearer ${Token}` },
        });
        setStock(res?.data);
        console.log("sandeep", res.data);
        setLoading(false);
      } catch (error) {
        console.error("error", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(Api_url, {
          headers: { "Content-Type": "application/json" },
        });
        setLogo(response.data.logo);
        setName(response.data.name);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };
    fetchLogo();
  }, []);

  //brandlogo
  const Api = `${apibasePath}/client/profiles/brand/`;
  const [brandLogo, setBrandLogo] = useState(null);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);

  //loading
  if (loading) {
    return (
      <div
        style={{
          top: "50%",
          left: "50%",
          translate: ("-50%", "-50%"),
          position: "absolute",
        }}
        className="slide"
      >
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  const handlePlus = async (item) => {
    if (openSubTable === item.customer_code) {
      setOpenSubTable(null); // close if already open
      return;
    }

    try {
      const response = await axios.get(
        `${apibasePath}/client/cart-details/${item.customer_code}/`,
        {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        },
      );

      setCustomerData(response?.data);
      setOpenSubTable(item.customer_code); // open selected row
    } catch (error) {
      console.error("Error fetching customer details:", error);
    }
  };

  const handleExcel = () => {
    // Prepare main sheet data
    const worksheetData = customerData.map((item) => ({
      "Customer Code": item.customer_code,
      Quantity: item.quantity,
      "Item Code": item.item_code,
      "Item Tag": item.item_tag,
      "Item Name": item.item_name,
      "Gross Weight": item.gross_weight,
      "Stone Weight": item.stone_weight,
      "Net Weight": item.net_weight,
    }));

    // Create a worksheet
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Cart Summary");

    // Save it as an .xlsx file
    XLSX.writeFile(workbook, "cart-details.xlsx");
  };

  const Api_PDF =
    "https://broker.accountiez.com/client/cart-details/1234/?download=true";

  const handlePDF = async (item) => {
    try {
      const response = await axios.get(
        `${apibasePath}/client/cart-details/${item.customer_code}/?download=true`,
        {
          headers: {
            Authorization: `bearer ${Token}`, // Capitalized "Bearer"
            "Content-Type": "application/json",
          },
          responseType: "blob", // if you're expecting a file like a PDF
        },
      );

      console.log("PDF Response:", response);

      // If you're setting the PDF blob in state to view/download
      setPdf(response.data);

      // Optional: If you want to trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "cart-details.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  const ExhibitionDropdown = () => (
    <NavDropdown
      title="EXHIBITION FORM"
      id="exhibition-dropdown"
      className="mt-2"
    >
      <NavDropdown.Item href="/createcustomer">
        • CREATE CUSTOMER
      </NavDropdown.Item>
      <NavDropdown.Item href="/orderentryform">
        • ORDER ENTRY FORM
      </NavDropdown.Item>
      <NavDropdown.Item href="/orderformprint">
        • ORDER FORM PRINT
      </NavDropdown.Item>
      <NavDropdown.Item href="/totalorderssummary">
        • TOTAL ORDERS SUMMARY
      </NavDropdown.Item>
    </NavDropdown>
  );

  return (
    <>
 



      {/* Main Content */}
      <main className="content">
        <div className="header-section" style={{ color: "#35646E" }}>
          <h2 style={{ fontFamily: "Roboto", color: "#35646E" }}>
            Add to cart summary
          </h2>
        </div>

        {/* //=============== */}
        <Table className="table" responsive striped bordered>
          <thead>
            <tr style={{ color: "#35646E", borderBottom: "1px solid black" }}>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              ></th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Customer Code
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Quantity
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Gross Weight
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Stone Weight
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Net Weight
              </th>
              {/* <th style={{ backgroundColor: '#C5CACF', color: '#35646E', fontFamily: 'Roboto' }}>Image</th> */}
            </tr>
          </thead>
          <tbody>
            {stock.map((item,idx) => (
              <React.Fragment key={idx}>
                <tr style={{ color: "#35646E" }}>
                  <td
                    align="center"
                    style={{
                      backgroundColor: "#C5CACF",
                      color: "#35646E",
                      fontFamily: "Roboto",
                    }}
                  >
                    <button
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        width: "30px",
                        height: "30px",
                        fontWeight: "bold",
                        fontSize: "25px",
                        color: "#396D72",
                      }}
                      onClick={() => handlePlus(item)}
                    >
                      {/* {openSubTable &&selectedItem === item ? <FiMinus /> : <FiPlus />} */}
                      {/* {openSubTable && selectedItem?.customer_code === item.customer_code ? <FiMinus /> : <FiPlus />} */}
                      {openSubTable === item.customer_code ? (
                        <FiMinus />
                      ) : (
                        <FiPlus />
                      )}
                    </button>
                  </td>
                  <td
                    style={{
                      backgroundColor: "#C5CACF",
                      color: "#35646E",
                      fontFamily: "Roboto",
                    }}
                  >
                    {item.customer_code}
                  </td>
                  <td
                    style={{
                      backgroundColor: "#C5CACF",
                      color: "#35646E",
                      fontFamily: "Roboto",
                    }}
                  >
                    {item.total_quantity}
                  </td>
                  <td
                    style={{
                      backgroundColor: "#C5CACF",
                      color: "#35646E",
                      fontFamily: "Roboto",
                    }}
                  >
                    {item.total_gross_weight % 1 === 0
                      ? item.gross_weight
                      : Number(item.total_gross_weight).toFixed(3) ||
                        "N/A"}{" "}
                    gm
                  </td>
                  <td
                    style={{
                      backgroundColor: "#C5CACF",
                      color: "#35646E",
                      fontFamily: "Roboto",
                    }}
                  >
                    {item.total_stone_weight % 1 === 0
                      ? item.total_stone_weight
                      : Number(item.total_stone_weight).toFixed(3) ||
                        "N/A"}{" "}
                    gm
                  </td>
                  <td
                    style={{
                      backgroundColor: "#C5CACF",
                      color: "#35646E",
                      fontFamily: "Roboto",
                    }}
                  >
                    {item.total_net_weight % 1 === 0
                      ? item.total_net_weight
                      : Number(item.total_net_weight).toFixed(3) || "N/A"}{" "}
                    gm
                  </td>
                </tr>

                {openSubTable === item.customer_code && (
                  <tr>
                    <td colSpan="9" style={{ backgroundColor: "#C5CACF" }}>
                      <table
                        id="my-table"
                        width="100%"
                        className="table table-bordered custom-table"
                      >
                        <thead>
                          <div style={{ marginLeft: "auto" }}>
                            {["down"].map((direction) => (
                              <NavDropdown
                                className="one"
                                as={ButtonGroup}
                                key={direction}
                                id={`dropdown-button-drop-${direction}`}
                                drop={direction}
                                // variant="secondary"
                                style={{ backgroundColor: "#C5CACF" }}
                                // style={{backgroundColor:'#396D72',color:'#fff',fontFamily:'Roboto'}}
                                title="Download"
                              >
                                <Dropdown.Item onClick={() => handlePDF(item)}>
                                  PDF <MdOutlineFileDownload />
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleExcel}>
                                  Excel
                                  <MdOutlineFileDownload />
                                </Dropdown.Item>
                              </NavDropdown>
                            ))}
                          </div>

                          <tr style={{ background: "#fff", color: "#35646E" }}>
                            <th>Image</th>
                            <th>Customer Code</th>
                            <th>Quantity</th>
                            <th>Item Code</th>
                            <th>Item tag</th>
                            <th>Item Name</th>
                            <th>Gross Weight</th>
                            <th>Stone Weight</th>
                            <th>Net Weight</th>
                            <th>Size</th>
                            <th>Comment</th>

                          </tr>
                        </thead>
                        <tbody>
                          {customerData.map((e,idx) => (
                            <tr
                              key={idx}
                              style={{
                                backgroundColor: "#fff",
                                color: "#35646E",
                              }}
                            >
                              <td
                                style={{
                                  width: "150px",
                                  height: "20vh",
                                  overflow: "hidden",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {/* <img
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    backgroundSize: "cover",
                                    objectFit: "cover",
                                  }}
                                  src={e.image}
                                /> */}
                                <LoadingImg product={e} />
                              </td>
                              <td>{e.customer_code}</td>
                              <td>{e.quantity}</td>
                              <td>{e.item_code}</td>
                              <td>{e.item_tag}</td>
                              <td>{e.item_name}</td>
                              <td>
                                {e.gross_weight % 1 === 0
                                  ? e.gross_weight
                                  : Number(e.gross_weight).toFixed(3) ||
                                    "N/A"}{" "}
                                gm
                              </td>
                              <td>
                                {e.stone_weight % 1 === 0
                                  ? e.stone_weight
                                  : Number(e.stone_weight).toFixed(3) ||
                                    "N/A"}{" "}
                                gm
                              </td>
                              <td>
                                {e.net_weight % 1 === 0
                                  ? e.net_weight
                                  : Number(e.net_weight).toFixed(3) ||
                                    "N/A"}{" "}
                                gm
                              </td>
                              <td>{e.size || "N/A"}</td>
                              <td>{e?.comment || "---"}</td>

                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
     
      </main>
    </>
  );
};
export default Cart;
